import { Button } from '@material-ui/core'
import React from 'react'

import { downloadCsv, downloadPdf } from './exportUtils'

// Reusable Excel(CSV) + PDF buttons. `getData()` returns
// { filename, title, headers, rows } from the page's current data.
const ExportButtons = ({ getData, size = 'small' }) => {
  const onExcel = () => {
    const d = getData && getData()
    if (!d || !d.rows || !d.rows.length) return
    downloadCsv(d.filename || 'export', d.headers, d.rows)
  }
  const onPdf = () => {
    const d = getData && getData()
    if (!d || !d.rows || !d.rows.length) return
    downloadPdf(d.filename || 'export', d.title || d.filename || 'Export', d.headers, d.rows)
  }
  return (
    <>
      <Button size={size} variant="outlined" onClick={onExcel}>
        ⬇ Excel
      </Button>
      <Button
        size={size}
        variant="outlined"
        onClick={onPdf}
        style={{ marginLeft: 8 }}>
        ⬇ PDF
      </Button>
    </>
  )
}

export default ExportButtons
